import React, { useState } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import MasterDataApiExplorer from '../../components/MasterDataApiExplorer';
import '../PageStyles.css';
import './MasterDataPage.css';

const sampleData = [
  { from: 'USD', to: 'INR', rate: 83.5, updated_at: '2026-02-10' },
  { from: 'USD', to: 'MXN', rate: 17.2, updated_at: '2026-02-10' },
  { from: 'GBP', to: 'INR', rate: 105.3, updated_at: '2026-02-10' },
];

const MasterDataExchangeRate = () => {
  const [showTryApi, setShowTryApi] = useState(false);

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>Exchange Rate</h2>
            <button type="button" className="btn btn-try-api" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>From</th>
                <th>To</th>
                <th>Rate</th>
                <th>Updated At</th>
              </tr>
            </thead>
            <tbody>
              {sampleData.map((row, i) => (
                <tr key={i}>
                  <td><code>{row.from}</code></td>
                  <td><code>{row.to}</code></td>
                  <td>{row.rate}</td>
                  <td>{row.updated_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <MasterDataApiExplorer slug="exchange-rate"  onClose={() => setShowTryApi(false)} />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MasterDataExchangeRate;
